import defaultProps from '@ui-system/default-props/list';
import { ListType } from '@ui-system/interfaces-list';
import { pleaseImplement } from '@ui-system/utils';

const List = pleaseImplement<ListType>('List');

List.defaultProps = defaultProps;

export default List;
